interface Converters {
  boolean(value: string | number): boolean;
}

const converters: Converters = {
  boolean(value: string | number) {
    return value === 'true' || value === 1;
  },
};

export { converters };
